import type {BackgroundColor, ColorMode} from '../types';
import {ThemeColors} from '../themeColors';

/**
 * @deprecated No need for this, use theme colors directly
 */
export const useBackgroundColor = (
  color: BackgroundColor = 'primary',
  mode: ColorMode = 'main',
): string => ThemeColors.background[color][mode];
